// extracted by mini-css-extract-plugin
export default {"Input":"Search_Input__oXaiS"};